import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';

const timeoutDesktop = getFeature('quota-landing-load-products-timeout');
const timeoutMobile = getFeature('quota-landing-load-products-timeout-mobile');

export const quotaLandingLoadProductsThresholdMobile = getFeature('quota-landing-load-products-threshold-mobile') || 0.1;

export const quotaLandingLoadProductsTimeout: number = IS_MOBILE_BROWSER ? timeoutMobile : timeoutDesktop;
